
$('.CLose_button svg').click(function (params) {  
  $('.main_gaint-popup').css("top","100%"); setTimeout(function() { 
  $('.main_gaint-popup_container').hide()
   $('body').removeClass('overFlowhidden')
  }, 400);
})
$('.Gaint_drop_down').click(function (params) {
  $('body').addClass('overFlowhidden')
  $('.main_gaint-popup_container').show();
  setTimeout(function() {
  $('.main_gaint-popup').css("top","15%");
}, 200);
})
 $(document).ready(function(){
    $('ul#products-grid').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: '<button class="top_bar_slick-arrows previous"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"> <rect x="-0.5" y="0.5" width="54.5091" height="54.5091" rx="27.2545" transform="matrix(-1 0 0 1 54.5091 0)" stroke="#AB8F44"/> <path d="M32.4455 39.8725C32.5993 39.8744 32.7518 39.8441 32.8932 39.7835C33.0346 39.7229 33.1617 39.6334 33.2664 39.5207C33.7355 39.0516 33.7355 38.3245 33.2664 37.8554L23.5328 28.1218L33.2664 18.4116C33.7355 17.9425 33.7355 17.2154 33.2664 16.7463C32.7973 16.2773 32.0703 16.2773 31.6012 16.7463L21.0701 27.3243C20.601 27.7934 20.601 28.5205 21.0701 28.9896L31.6246 39.5207C31.8592 39.7553 32.1641 39.8725 32.4455 39.8725Z" fill="#AB8F44"/> </svg></button>',
      nextArrow: '<button class="top_bar_slick-arrows nxt"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none"> <rect x="-0.5" y="0.5" width="54.5091" height="54.5091" rx="27.2545" transform="matrix(-1 0 0 1 54.5091 0)" stroke="#AB8F44"/> <path d="M32.4455 39.8725C32.5993 39.8744 32.7518 39.8441 32.8932 39.7835C33.0346 39.7229 33.1617 39.6334 33.2664 39.5207C33.7355 39.0516 33.7355 38.3245 33.2664 37.8554L23.5328 28.1218L33.2664 18.4116C33.7355 17.9425 33.7355 17.2154 33.2664 16.7463C32.7973 16.2773 32.0703 16.2773 31.6012 16.7463L21.0701 27.3243C20.601 27.7934 20.601 28.5205 21.0701 28.9896L31.6246 39.5207C31.8592 39.7553 32.1641 39.8725 32.4455 39.8725Z" fill="#AB8F44"/> </svg></button>',

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });

$(".iwt-container").slick({
    speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
    slidesToShow: 5,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true, 
    arrows: false,
    dots: false,
    focusOnSelect: true,
    responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
            ]
});

$('.main_slider_media').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  // draggable: false,
  fade: true,
  // infinite:false,
 focusOnSelect: false,
  asNavFor: '.main_product_thumbnails',
  prevArrow: '<div class="swiper-button-next focus-inset" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-f733c4da4dac5be9" aria-disabled="false"> <svg class="icon icon-caret-right" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.451 4.24896C13.1191 3.91701 12.5809 3.91701 12.249 4.24896C11.917 4.5809 11.917 5.1191 12.249 5.45104L17.7977 10.9998L3.85 10.9998C3.38056 10.9998 3 11.3803 3 11.8498C3 12.3192 3.38056 12.6998 3.85 12.6998L17.7982 12.6998L12.249 18.249C11.917 18.5809 11.917 19.1191 12.249 19.451C12.5809 19.783 13.1191 19.783 13.451 19.451L20.451 12.451C20.5003 12.4018 20.5429 12.3471 20.5782 12.2885C20.6501 12.1691 20.692 12.033 20.699 11.8921C20.6996 11.8781 20.7 11.8641 20.7 11.85C20.7 11.8499 20.7 11.8498 20.7 11.8498C20.7 11.6089 20.5998 11.3914 20.4388 11.2367L13.451 4.24896Z" fill="currentColor"></path> </svg> </div>',
  nextArrow: '<div class="swiper-button-prev focus-inset" tabindex="0" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-f733c4da4dac5be9" aria-disabled="false"> <svg class="icon icon-caret-left" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2492 19.451C10.5811 19.783 11.1193 19.783 11.4512 19.451C11.7832 19.1191 11.7832 18.5809 11.4512 18.2489L5.90252 12.7002L19.8502 12.7002C20.3196 12.7002 20.7002 12.3197 20.7002 11.8502C20.7002 11.3808 20.3196 11.0002 19.8502 11.0002L5.90203 11.0002L11.4512 5.45103C11.7832 5.11908 11.7832 4.58089 11.4512 4.24895C11.1193 3.917 10.5811 3.917 10.2492 4.24895L3.24915 11.2489C3.19991 11.2982 3.15734 11.3528 3.12201 11.4115C3.05011 11.5309 3.00823 11.667 3.00124 11.8078C3.00054 11.8218 3.00019 11.8359 3.00019 11.85C3.00019 11.8501 3.00019 11.8502 3.00019 11.8502C3.00019 12.0911 3.10039 12.3086 3.26138 12.4633L10.2492 19.451Z" fill="currentColor"></path> </svg> </div>'
  
});
$('.main_product_thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  vertical:false,
  arrows: false,
  infinite:false,
   // draggable: false,
  asNavFor: '.main_slider_media',
  dots: false,
  focusOnSelect: true
});

$('.main_gaint-popup .about').click(function () {
    const toggle = $(this).find('.about__accordion-toggle');
    const desc = $(this).find('.about__accordion-description');
    const plusminus = $(this).find('.plusminus');

    const isActive = toggle.hasClass('active');

    if (isActive) {
        // already open → close it
        toggle.removeClass('active');
        desc.css('display', 'none');
        plusminus.removeClass('active');
    } else {
        // open it
        toggle.addClass('active');
        desc.css('display', 'block');
        plusminus.addClass('active');
    }
});

$('.about__accordion-item').click(function (e) {
    e.stopPropagation(); // 👈 parent .about par nahi jayega
});


// function updateImages(params) {
//     let imagesrc = $('.main_slider_media .slick-slide.slick-current.slick-active img').attr('alt')
//     $('.product-form__controls-group label.hassImage').each(function (params) {
//         let srcc = $(this).attr('alt')
//         if(srcc === imagesrc){
//            $(this).trigger('click')
           
//         }
        
//     })
// }

// $('.main_slider_media .slick-arrow').click(function (params) {
//     updateImages()
// })

function updateImages() {
    let imagesrc = $('.main_slider_media .slick-slide.slick-current.slick-active img').attr('alt');

    $('.product-form__controls-group label.hassImage').each(function () {
        let srcc = $(this).attr('alt');
        if (srcc === imagesrc) {
            let input = $(this).attr('for')
                ? document.getElementById($(this).attr('for'))
                : $(this).find('input')[0];

            if (input) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true })); // native event
            }
        }
    });
}

$('.main_slider_media .slick-arrow').on('click', updateImages);



function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count;
      const $bubble = $('.cart-count-bubble span[aria-hidden="true"]');

      if (count > 0) {
        $bubble.text(count);
        $('.cart-count-bubble').show();
      } else {
        $bubble.text('');
        $('.cart-count-bubble').hide();
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}
setInterval(updateCartCount, 2000);
